import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Icon, Text } from "@quintoandar-tokko/jopijs";
import {
  likeContainer,
  likeAsk,
  feedbackReview,
  iconsContainer,
  feedbackRegradeBtn,
} from "./feedback.module.scss";
import translations from "../FichaInfo.trans.json";
import Trans from "@/components/shared/Trans";
import FeedbackModal from "./Modal/FeedbackModal";
import { setResetFichaInfoState } from "@/store/slices/components/fichaInfo/FichaInfoSlice";
import ErrorCapture from "@/components/errorBoundary/index";

export default function FeedbackLike() {
  const dispatch = useDispatch();
  const { isEdition, feedback, contact_name } = useSelector(
    (state) => state.FichaInfoSlice
  );
  const [showModal, setShowModal] = useState({ show: false, like: false });
  const { feedbackSended, likeProperty } = feedback;
  const show_feedback = !isEdition && contact_name;

  if (!show_feedback) return null;

  return (
    <ErrorCapture>
      <Box __css={{ marginTop: "16px" }} className={likeContainer}>
        <Box>
          {!feedbackSended ? (
            <Box className={likeAsk}>
              <Text>
                {contact_name}, {Trans(translations, "FeedbackLikeText")}
              </Text>
            </Box>
          ) : (
            <Box __css={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <Icon
                icon={`${
                  likeProperty ? "icon-destaque" : "icon-quitardestaque"
                }`}
                fontSize="24px"
              />
              <Text className={feedbackReview}>
                {Trans(
                  translations,
                  likeProperty
                    ? "FeedbackLikeProperty"
                    : "FeedbackDontLikeProperty"
                )}
              </Text>
            </Box>
          )}
        </Box>
        {!feedbackSended ? (
          <Box className={iconsContainer} __css={{ minWidth: "96px" }}>
            <Icon
              icon="icon-destaque"
              fontSize="16px"
              onClick={() => setShowModal({ show: true, like: true })}
            />
            <Icon
              icon="icon-quitardestaque"
              fontSize="16px"
              onClick={() => setShowModal({ show: true, like: false })}
            />
          </Box>
        ) : (
          <Button
            variant={["primaryOutlined"]}
            fontSize="14px"
            borderRadius="7px"
            fontWeight="700"
            padding="7px 16px"
            className={feedbackRegradeBtn}
            onClick={() => {
              dispatch(setResetFichaInfoState({ key: "feedback" }));
            }}
            borderColor="var(--colors-neutral-grey-400)"
          >
            {Trans(translations, "FeedbackRequalify")}
          </Button>
        )}
        <FeedbackModal showModal={showModal} setOpen={setShowModal} />
      </Box>
    </ErrorCapture>
  );
}
